module.exports = __webpack_public_path__ + "static/img/chanta (13).a116163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (13).jpg
// module id = OdgM
// module chunks = 0